import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { HttpMethods, SERVICES } from '../../services/api';
import apiAsyncThunkCreator from '../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../rootReducer';
import { ISectionsAccessPermissions } from './user';
import { showErrorMessage, showSuccessMessage } from '../notifications';
import { Features, isFeatureEnabled } from '../../featureToggles/features';

export interface IUpdateUserPermissionsData {
  permissions: ISectionsAccessPermissions;
  userId: string;
}

export const updateSectionAccessPermissions: AsyncThunk<void, IUpdateUserPermissionsData, ThunkAPI> = createAsyncThunk(
  'users/updateSectionAccessPermissions',
  (data: IUpdateUserPermissionsData, thunk) => {
    if (!isFeatureEnabled(Features.SectionsPermissions)) {
      thunk.dispatch({
        type: 'DO_NOTHING'
      });
      return;
    }
    return apiAsyncThunkCreator<void, ISectionsAccessPermissions>({
      endpoint: `users/${data.userId}/section-access-permissions`,
      microservice: SERVICES.USERS_SERVICE,
      authenticated: true,
      method: HttpMethods.Put,
      types: [[
        showSuccessMessage('User updated')
      ], [
        showErrorMessage('There was an error, please try again later')
      ]]
    })(data.permissions, thunk);
  }
);